var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaesarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M0 0h12v6H0zM14 0h12v6H14zM28 0h12v6H28zM0 7h12v6H0zM14 7h12v6H14zM28 7h12v6H28zM0 14h12v6H0zM14 14h12v6H14zM28 14h12v6H28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaesarIcon);
export default __webpack_public_path__ + "static/media/caesar_icon.e94d32682b233153d5e8801747af293e.svg";
export { ForwardRef as ReactComponent };